// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const es = {
  demo: {
    title: `Español`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hola`,
    description: `¿Necesitas ayuda? \n Por favor ve nuestra documentación.`,
    documentation: `Documentación`,
  },
  login: {
    welcome: 'Bienvenido',
    title: 'Ingresar a Timi',
    subtitle: 'Ingresa tus credenciales.',
    dontHaveAnAccount: '¿No tienes cuenta?',
    email: 'Correo',
    password: 'Contraseña',
    emailPlaceholder: 'Correo electronico',
    remember: 'Recuérdame',
    forgot: '¿Olvidaste tu contraseña?',
    login: 'Iniciar sesión',
    or: 'O',
    register: 'Regístrate',
    success: '¡Bienvenido/a! Estamos felices de tenerte de vuelta.',
    error: '¡Ups! Algo salió mal. Por favor, inténtalo de nuevo.',
    error_email: 'Email no válido',
    MEMBER_NOT_FOUND: 'Email no válido',
    error_password: 'XXXXXXXXña no válida',
    error_remember: 'Recuérdame no válido',
    error_login: 'Error al iniciar sesión',
    error_register: 'Error al registrar',
    error_forgot: 'Error al enviar correo de recuperación',
    error_forgot_email: 'Email no válido',
    error_forgot_password: 'XXXXXXXXña no válida',
    error_forgot_remember: 'Recuérdame no válido',
    error_forgot_success: '¡Correo de recuperación enviado! Por favor, revisa tu bandeja de entrada.',
    error_forgot_error: '¡Ups! Algo salió mal. Por favor, inténtalo de nuevo.',
  },
  menu: {
    checker: 'Checador',
    members: 'Miembros',
    attendance: 'Lista de asistencia',
  },
  checker: {
    title: 'Checador',
    placeholderCheckerInput: 'Ingresa tu email@vinnere.com.mx',
    erroValidationEmail: 'El email no es valido',
    successCheckin: '¡Tu registro fue exitoso!',
    qrWelcome: 'Bienvenido',
    qrDescriptor: 'Escanea el siguiente código para marcar tu asistencia',
    employerListTitle: 'Hoy en oficina',
    colaborator: 'Colaborador',
    hour: 'Hora',
    checkerSubmitButton: 'Registrar',
  },
  attendance: {
    titlePage: 'Checador: Asistencia',
    title: 'Lista de Asistencia',
    tableHeadersColaborator: 'Colaborador',
    tableHeadersOwner: 'Lider',
    tableHeadersPosition: 'Puesto',
    tableHeadersCheckin: 'Entrada',
    tableHeadersCheckout: 'Salida',
    tableHeadersEstatus: 'Estatus',
    tableHeadersMedio: 'Medio',
    downloadExcel: 'Descargar Excel',
    startDate: 'Fecha Inicio',
    endDate: 'Fecha Fin',
    placeholderSerach: 'Filtrar por Nombre o E-mail...',
  },
  members: {
    pageTitle: 'Miembros',
    tableHeadersFullName: 'Colaborador',
    tableHeadersEmail: 'Email',
    tableHeadersPosition: 'Posición',
    tableHeadersOwner: 'Lider',
    tableHeadersStatus: 'Estatus',
    alertTitle: '¿Etas seguro de ejecurtar esta operación?',
    alertConfirmation: 'Por favor confirma esta operación.',
    alertCancel: 'Cancelar',
    alertConfirm: 'Confirmar',    
  },
  member: {
    pageTitle: 'Detalle',
    attendanceHistory: 'Historial de Asistencia',
    position: 'Puesto',
    owner: 'Lider',
    status: 'Estatus',
    previousWeek: 'Semana Previa',
    nextWeek: 'Siguiente Semana',
    tableHeadersDate: 'Fecha',
    tableHeadersCheckin: 'Entrada',
    tableHeadersCheckout: 'Salida',
    tableHeadersMedio: 'Medio',
    tableHeadersEstatus: 'Estatus',
    tableHeadersAcciones: 'Acciones',
    homeAddress: 'Dirección de Casa',
    officeAddress: 'Dirección de Oficina',
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2: `menu level 2`,
  menu_level_3: `menu level 3`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
};

export default es;
